module.exports = __webpack_public_path__ + "img/downloadApp.803f78bf.jpg";